import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { LocationsRepository } from "../../repositories";
import { RemoveOrUnassignedLocationsRequest } from "../../domain/requests";

@Injectable({ providedIn: 'root' })
export class RemoveOrUnassignedLocationsUsecase implements UseCase<RemoveOrUnassignedLocationsRequest, boolean> {
  constructor(private readonly locationRepository: LocationsRepository) {}

  execute(params: RemoveOrUnassignedLocationsRequest): Observable<boolean> {
    return this.locationRepository.removeOrUnassignedLocations(params);
  }
}